import styled from 'styled-components'
import UiLink from "../../../../components/Link";
import UiButton from "../../../../components/Button";

export const Backdrop = styled('div')`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0;
  background: none;
`

export const Content = styled('div')`
  border-radius: 6px;
  width: 100%;
  max-width: 390px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Avatar = styled('div')`
  width: 90px;
  height: 90px;
  border-radius: 100%;
  overflow: hidden;

  img { 
    width: 100%;
    height: auto;
    display: block;
  }
`

export const H3 = styled('h3')`
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
  margin: 0px;
  text-align: center;
`

export const H2 = styled('h2')`
  font-size: 26px;
  line-height: 30px;
  font-weight: 500;
  margin: 0px;
  text-align: center;
`

export const Link = styled(UiLink)`
  max-width: 250px;
`

export const Back = styled("a")`
  margin-right: auto;
  color: black;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  line-height: 36px;
  margin-top: 15px;

  &:hover {
    text-decoration: underline;
  }

  span {
    display: none;
    margin-left: 16px;
    @media (min-width: 768px) {
      display: block;
    }
  }
`;

export const ChangeAccountLink = styled(UiButton)`
  padding: 0px;
  margin: 0px;
  border: none;
  width: auto;
  min-width: 0px;
  line-height: 36px;
  background-color: transparent;
  position: relative;
  color: ${({ theme }) => theme.colors.Primary};
  font-size: 14px;
  text-align: center;

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.Primary};
    position: absolute;
    bottom: 0px;
    transition: height .2s ease-in-out;
  }

  &:hover {
    background-color: none;
    box-shadow: none;
    text-decoration: none;

    &:after {
      height: 2px;
    }
  }
`

export const SignInLink = styled(UiLink)`
  padding: 0px;
  margin: 0px;
  border: none;
  width: auto;
  display: block;
  min-width: 0px;
  line-height: 28px;
  background-color: transparent;
  position: relative;
  font-size: 14px;
  color: #2D3436;
  text-align: center;
  margin-left: 15px;

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #2D3436;
    position: absolute;
    bottom: 0px;
    transition: height .2s ease-in-out;
  }

  &:hover {
    background-color: none;
    box-shadow: none;
    text-decoration: none;

    &:after {
      height: 2px;
    }
  }
`

export const Hello = styled('div')`
  font-size: 14px;
  font-weight: normal;
`

export const AccountSignIn = styled("p")`
  margin: 0px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ChangeAccount = styled('div')`
  margin: 0px;
  text-align: center;
`